<template>
  <div :to="`/transaksi/${id}`" data-testid="trx-card-link" class="trx-card" @click="onClick">
    <div>
      <BlProductImageAv
        :image-url="courseImg"
        image-placeholder="https://s2.bukalapak.com/attachment/237412/placeholder.png"
        object-fit="cover"
        class="rounded"
      />
    </div>
    <div>
      <BlTextAv variation="body-14" class="name-text" :ellipsis="2" weight="medium" data-testid="trx-card-name">{{ name }}</BlTextAv>
      <BlTextAv variation="caption-12" class="mt-4" data-testid="trx-card-merchant-name">{{ merchantName }}</BlTextAv>
    </div>
  </div>
</template>

<script>
import {BlProductImageAv, BlTextAv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'PrakerjaItem',
  components: {
    BlTextAv,
    BlProductImageAv,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    merchantName: {
      type: String,
      required: true,
    },
    courseImg: {
      type: String,
      required: true,
    },
  },
  methods: {
    onClick() {
      const path = window.location.pathname;
      const segments = path.split('/');
      if (segments?.[1] === 'kartu-prakerja') {
        this.$router.push(`/transaksi/${this.id}`);
        return;
      }
      window.location.href = `${window.location.origin}/kartu-prakerja/transaksi/${this.id}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.trx-card {
  padding: 12px;
  border: 1px solid #d6d6d6;
  border-radius: 12px;
  display: flex;
  gap: 16px;
  text-decoration: none;
}
.name-text {
  max-width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-wrap: break-word;
}
</style>
